const useDoesPreferDarkMode = () => {
  const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)')

  return prefersDarkMode.matches
}

export default useDoesPreferDarkMode
